import { OptionsEnum } from '../../enums/OptionsEnum';
import { AddressDto } from '../AddressDto';

export class InsuredDetails {
  initials = '';
  middleName = '';
  surname = '';
  gender = '';
  dateOfBirth: Date;
  zipCode = '';
  houseNumber = '';
  houseNumberSuffix = '';
  street = '';
  city = '';
  mobilePhoneNo = '+31 (0)';
  emailAddress = '';
  confirmedEmailAddress = '';
  nationality = 'NL';
  iban = '';
  addressSameAsFirstInsured: OptionsEnum = OptionsEnum.Yes;
  isSmoker: boolean;
  phoneNumber = '';
  address: AddressDto;
  occupation: string;
}
